import React from "react";
import { Table, Tag, Space, Row, Button, Col, Input } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

import AppCard from "../../components/AppCard";

const FreeUserList = () => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Tags",
      key: "tags",
      dataIndex: "tags",
      render: (tags) => (
        <>
          {tags.map((tag) => {
            let color = tag.length > 5 ? "geekblue" : "green";
            if (tag === "loser") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          delete
        </Space>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];
  return (
    <div>
      <AppCard heading="Free User List">
        <Row justify="space-between" className="mb-2">
          <Col xs={24} md={12}>
            <Button type="primary" icon={<PlusCircleOutlined />}>
              Create New User
            </Button>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Input.Search placeholder="input search text" enterButton />
          </Col>
        </Row>
        <Table columns={columns} dataSource={data} />
      </AppCard>
    </div>
  );
};

export default FreeUserList;
